import React from 'react'
import {
  DateField,
  SelectInput,
  DateInput,
  TextInput,
  TextField,
  Labeled,
} from 'react-admin'
import {
  invoiceStatusList,
  accountingStatusList,
  paymentStatusList,
} from 'services/cfg/form'
import { getGeoLang } from 'services/geo-management'
import { optionsDate } from 'services/utils/date'

const ConfirmedTransactionFields: React.FC = (props) => {
  const lang = getGeoLang()

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', maxWidth: '256px' }}
    >
      <Labeled label="Confirmed at">
        <DateField
          source="confirmedAt"
          locales={lang}
          options={optionsDate}
          // spreading props to pass down record, not needed in RA4
          {...props}
        />
      </Labeled>
      <SelectInput source="invoiceStatus" choices={invoiceStatusList} />
      <SelectInput source="accountingStatus" choices={accountingStatusList} />
      <SelectInput source="paymentStatus" choices={paymentStatusList} />
      <DateInput
        source="invoiceExpiryDate"
        // #ra4Migration check here!
        // locales={lang}
      />
      <TextInput source="invoiceNumber" />
      <Labeled label="Payment Method">
        <TextField
          source="paymentMethod"
          // spreading props to pass down record, not needed in RA4
          {...props}
        />
      </Labeled>
      <TextInput source="poNumber" />
    </div>
  )
}

export default ConfirmedTransactionFields
